import {inject, Injectable} from '@angular/core';
import {Actions, createEffect} from '@ngrx/effects';
import {filter, map} from 'rxjs';
import {PaginationActions} from '@aviary/store/pagination/pagination.actions';
import {isDefined, isObject} from '@aviary/store/common/typing.helpers';
import {isListData} from '@aviary/store/common/common.types';
import {RouterActions} from '@aviary/store/router/router.actions';

// eslint-disable-next-line @angular-eslint/use-injectable-provided-in -- This is registered via NgRx; it's not an Angular DI tree-shakable provider.
@Injectable()
export class PaginationEffects {

  private readonly actions: Actions = inject(Actions);

  public updateFromAppropriateActions = createEffect(() =>
    this.actions.pipe(
      map(action => {
        if (!isObject(action)) return;

        const listData: unknown = action['listData'];

        return isListData(listData) ? listData.paginationInfo : undefined;
      }),
      filter(isDefined),
      map(paginationInfo => paginationInfo.page > 1 &&
        paginationInfo.page > Math.ceil(paginationInfo.totalCount / paginationInfo.pageSize) // If this is true, our page number is out of bounds...
          ? RouterActions.updatePaginationParams(1, paginationInfo.pageSize)                 // ...so reset to page 1...
          : PaginationActions.update(paginationInfo)                                         // ...otherwise we're good, so update the store with this data.
      )
    )
  );
}
